/**** Utility Methods ****/

(function(){
  var handle_bar = document.createElement("script");
  var script = document.createElement("script");
  var link = document.createElement("link");
  handle_bar.src = "https://cdn.jsdelivr.net/npm/handlebars@latest/dist/handlebars.js";
  script.src = "https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/js/toastr.min.js";
  script.type = "text/javascript";
  link.href = "https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/css/toastr.css";
  link.type = "text/css";
  link.rel = "stylesheet";
  document.head.appendChild(script);
  document.head.appendChild(link);
  document.head.appendChild(handle_bar);
  script.onload = function(){
    toastr.options.timeOut = 1000;
    toastr.options.showEasing = 'linear';
  }
})();

function truncateString(str, num) {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setIDs_LocalStorage(ids){
  let itemsArray = ids.items.map(function(item){
    return item.prod_id;
  });
  localStorage.setItem('wishify_ids',JSON.stringify(itemsArray));
}

function getIDs_LocalStorage(){
  let items = localStorage.getItem('wishify_ids');
  if(items){
  	return JSON.parse(items);	
  }else{
  	return null;
  }
}

function _addIdIntoLocalStorage(pid){
  let items = localStorage.getItem('wishify_ids');
  if(items){
  	items = JSON.parse(items);
    if(!items.includes(pid)){
    	items.push(pid);
    }
    localStorage.setItem('wishify_ids',JSON.stringify(items));
  }
}

function _removeIdFromLocalStorage(pid){
  let items = localStorage.getItem('wishify_ids');
  if(items){
  	items = JSON.parse(items);
    items = items.filter((item)=>{
    	return item != pid;
    });
    localStorage.setItem('wishify_ids',JSON.stringify(items));
  }
}

function setProducts_LocalStorage(products){
  let items = [],prods=null;
  prods = products.products;
  items = prods.map((product)=>{
  	return JSON.parse(product.prod_data);
  });
  localStorage.setItem('wishify_products',JSON.stringify(items));
}

function _getProducts_LocalStorage(){
  let items = localStorage.getItem('wishify_products');
  return JSON.parse(items);
}

function _addProductIntoLocalStorage(pid){
  const product_data = WishifyViewProducts[pid];
  let items = localStorage.getItem('wishify_products');
  let is_contain = false;
  if(items){
  	items = JSON.parse(items);
    items.forEach((item)=>{
      if(item.id == pid) is_contain = true;
    });
    if(is_contain) return;
    items.push(product_data);
    localStorage.setItem('wishify_products',JSON.stringify(items));
  }  
}

function _getProductFromLocalStorage(pid){
  let items = localStorage.getItem('wishify_products');
  let product = null;
  if(items){
  	items = JSON.parse(items);
    product = items.filter(function(item){
    	return item.id == pid;
    });
    return product[0];
  }
  return false;
}

function _removeProductIntoLocalStorage(pid){
  let items = localStorage.getItem('wishify_products');
  if(items){
    items = JSON.parse(items);
    items = items.filter((item)=>{
    	return item.id != pid;
    });
    localStorage.setItem('wishify_products',JSON.stringify(items));
  }
}

var product_template = `
<div class="product__card">
	<a href="{{product.url}}" class="card__link">
	<div class="card__image" style="background-image:url('{{product.featured_image}}')">
	<button class="card__close-btn wishify-remove-product__trigger" aria-label="Close__card" data-product-id="{{product.id}}">&times;</button>
    </div>
    <div class="card__body">
      <div class="product__details">
		<span class="card__title">{{title}}</span>
      	<span class="card__price">$10.00</span>
      </div>
    {{#if product.available}}
        <button class="card__btn wishify-add-to-cart--trigger" data-id="{{variant_id}}">Add To cart</button>
    {{else}}
    	<button class="card__btn" disabled>Sold Out</button>
    {{/if}}
    </div>
  </a>
</div>
`;

var empty_template = `
<div class="wishify__empty">
    <h3>Love it? Add to Wishlist.</h3>
    <p>My Wishlist allows you to keep track of all of your favorites and shopping activity whether you're on your computer, phone, or tablet. You won't have to waste time searching all over again for that item you loved on your phone the other day - it's all here in one place!</p>
</div>
`;

/* ================ SETUP ================ */
window.wishify = window.wishify || {};

wishify.setup = (function() {
  var selectors = {
    wishifyContainer : '.wishify-container',
    wishifyBtn : '.wishify-btn',
    wishifyProductsContainer : '.wishlist__cards-main',
    wishifyProductRemoveBtn : '.wishify-remove-product__trigger',
    wishifyAddToCartBtn : '.wishify-add-to-cart--trigger',
    wishifyQuantity : '.wishify-quantity',
  };
  var config = {
    api_url: 'https://wishify.thebeautycorp.com/api',
    store : Shopify.shop
  };
  
  const container = document.querySelector(selectors.wishifyContainer);
  const customer_id =container.dataset.customerId;
  const customer_uid = getCookie('wishify-uid');
  
  async function setCustomer(cid,uid){
    const uuid =await fetch(`${config.api_url}/customers/set`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customer_id: cid, 
        customer_uid: uid,
        shop: config.store
      })
    })
    .then(res=>res.json())
    .then(function(data){
      let obj = JSON.parse(data);
      return obj.uuid;
    })
    .catch(function(error){
      console.log(error);
    });
    
    if(cid){
    	setCookie('wishify-cid',cid,365);
    }
    
    if(uuid){
      	setCookie('wishify-uid',uuid,365);
    }
    
    return true;
  }
  
  function _updateButtons(){
    let items = getIDs_LocalStorage();
    if (!items) return
  	var btns = document.querySelectorAll(selectors.wishifyBtn);
    for (var i = 0, btn; btn = btns[i++];) {
		let pid = btn.dataset?.productId;
        if(items.includes(pid)){
        	btn.classList.add('wishify-added');
        }else{
        	btn.classList.remove('wishify-added');
        }
    }
  }
  
  async function getIDs(cid,uid){
  	const _ids = await fetch(config.api_url+'/ids/get', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customer_id: cid, 
        customer_uid: uid,
        shop: config.store
      })
    })
    .then(res=>res.json())
    .then(function(data){
      let obj = JSON.parse(data);
      return obj;
    })
    .catch(function(error){
      console.log(error);
    });
    return  _ids;
  }
  
  async function getProducts(cid,uid){
   	const _products = await fetch(config.api_url+'/products/get', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customer_id: cid, 
        customer_uid: uid,
        shop: config.store
      })
    })
    .then(res=>res.json())
    .then(function(data){
      let obj = JSON.parse(data);
      return obj;
    })
    .catch(function(error){
      console.log(error);
    });
    return  _products;
  }
  
  async function _updateProductStatus(pid){
    const product_data = WishifyViewProducts[pid]; 
    if(!product_data) return;
    const product_title = truncateString(product_data.title,20);
  	const response = await fetch(`${config.api_url}/items/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customer_id: customer_id, 
        customer_uid: customer_uid,
        shop: config.store,
        product_id: pid,
        product_data: product_data
      })
    })
    .then(res=>res.json())
    .then(function(data){
      let obj = JSON.parse(data);
      return obj;
    })
    .catch(function(error){
      console.log(error);
    });
    var btns = document.querySelectorAll(selectors.wishifyBtn+'[data-product-id="'+pid+'"]');
    console.log("Btn is>>",btns);
    console.log("Response is>>", response.added);
    if(response.added){
      for (var i = 0, btn; btn = btns[i++];) {
        btn.classList.add('wishify-added');
      }
      _addIdIntoLocalStorage(pid);
      _addProductIntoLocalStorage(pid);
      toastr.success("<b>"+product_title+"</b><br> added Successfuly!");
    }else{
      for (var i = 0, btn; btn = btns[i++];) {
        btn.classList.remove('wishify-added');
      }
      _removeIdFromLocalStorage(pid);
      _removeProductIntoLocalStorage(pid);
      toastr.warning("<b>"+product_title+"</b><br> removed Successfuly!");
    }
    _updateQuantityUI();
  }
  
  async function _removeProduct(e){
    e.preventDefault();
  	let id = e.currentTarget.dataset.productId;
    const product_data = _getProductFromLocalStorage(id);
    if(!product_data) return;
    const product_title = truncateString(product_data.title,20);
  	const response = await fetch(`${config.api_url}/items/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customer_id: customer_id, 
        customer_uid: customer_uid,
        shop: config.store,
        product_id: id,
        product_data: product_data
      })
    })
    .then(res=>res.json())
    .then(function(data){
      let obj = JSON.parse(data);
      return obj;
    })
    .catch(function(error){
      console.log(error);
    });
    if(response.added){
      _addIdIntoLocalStorage(id);
      _addProductIntoLocalStorage(id);
      toastr.success("<b>"+product_title+"</b><br> added Successfuly!");
    }else{
      _removeIdFromLocalStorage(id);
      _removeProductIntoLocalStorage(id);
      toastr.warning("<b>"+product_title+"</b><br> removed Successfuly!");
    }
    if(response) _updateListUI();
  }
  
  async function _addToCart(e){
    e.preventDefault();
    let elem = e.currentTarget;
    elem.innerHTML = "Adding...";
    let id = elem.dataset.id;
    let formData = {
      'items': [{
        'id': id,
        'quantity': 1
      }]
    };
    let added =await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    if(added){
    	toastr.success("Added to the cart Successfuly!");
      	elem.innerHTML = "Add To cart";
        if(MiniCart != undefined){
          MiniCart.init();
        }
    }
  }
  
  function _productCardListeners(){
    let addToCartBtns = document.querySelectorAll(selectors.wishifyAddToCartBtn);
    let removeBtns = document.querySelectorAll(selectors.wishifyProductRemoveBtn);
    for(var i = 0, btn; btn = removeBtns[i++];){
      btn.addEventListener('click',_removeProduct);
    }
    for(var i = 0, btn; btn = addToCartBtns[i++];){
      btn.addEventListener('click', _addToCart);
    }
  }
  
  function _updateQuantityUI(){
    let products = _getProducts_LocalStorage();
    let elems = document.querySelectorAll(selectors.wishifyQuantity);
    for (var i = 0, elem; elem = elems[i++];) {
      elem.innerHTML = products.length;
    }
  }
  
  function _updateListUI(){
    _updateQuantityUI();
  	let products = _getProducts_LocalStorage();
    let data = '';
    if(products.length > 0){
      products.forEach((product)=>{
        let template = Handlebars.compile(product_template);
        let title = truncateString(product.title, 20);
        let variant_id =  product.variants[0].id;
        // execute the compiled template and print the output to the console
        data += template({ product, title, variant_id });
      });
      document.querySelector(selectors.wishifyProductsContainer).innerHTML = data;
      _productCardListeners();
    }else{
      let template = Handlebars.compile(empty_template);
      data = template({});
      document.querySelector(selectors.wishifyProductsContainer).innerHTML = data;
    }
    
  }
  
  function _openProductList(e){
  	e.preventDefault();
    let popup = selectors.wishifyContainer+' .rf--content__inner';
    _updateListUI();
    popup = document.querySelector(popup);
    popup.classList.add('is-visible');
  }
  function _closeProductList(e){
  	e.preventDefault();
    let popup = selectors.wishifyContainer+' .rf--content__inner';
    popup = document.querySelector(popup);
    popup.classList.remove('is-visible');
  }
  
  function addListeners(){
    var btns = document.querySelectorAll(selectors.wishifyBtn);
    var list_btn = document.querySelectorAll('.wishify-list--trigger');
    var list_btn_close = document.querySelectorAll('.wishify-list-close--trigger');
    for (var i = 0, btn; btn = btns[i++];) {
      btn.addEventListener('click',function(e){
        e.preventDefault();
       let product_id = e.currentTarget.dataset.productId;
       _updateProductStatus(product_id);
      });
    }
    for(var i = 0, btn; btn = list_btn[i++];){
      btn.addEventListener('click',_openProductList);
    }
    for(var i = 0, btn; btn = list_btn_close[i++];){
      btn.addEventListener('click',_closeProductList);
    }
  }
  
  async function _setupCustomer(){
    if(!customer_id){
    	setCookie('wishify-cid','',365);
    }
    let  is_set = false;
    if(!customer_id && !customer_uid){
    	is_set = await setCustomer(customer_id, customer_uid);
    }else if(customer_uid && customer_id != getCookie('wishify-cid')){
    	is_set = await setCustomer(customer_id, customer_uid);
    }else if(!customer_uid){
    	is_set = await setCustomer(customer_id, customer_uid);
    }else if(customer_id && !getCookie('wishify-cid')){
    	is_set = await setCustomer(customer_id, customer_uid);
    }
    if(is_set){
      const  _ids = await getIDs(customer_id,customer_uid);
      const _products = await getProducts(customer_id, customer_uid);
      setIDs_LocalStorage(_ids);
      setProducts_LocalStorage(_products);
    }
    return true;
  }
  
  async function _setupUI(){
  	_updateButtons();
    _updateQuantityUI();
  }
  
  async function init(){
    let is_done = await _setupCustomer();
    if(is_done){
      _setupUI();
    }
  }
  
  return {
    init: init,
    listeners:addListeners
  };
})();


wishify.setup.init();
wishify.setup.listeners();